'use client';

import { usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import Certifications from './certifications';
import Coulmns from './columns';
import ConnectionDetails from './connection-details';
function Footer() {
  const pathName = usePathname();
  const hasBottomPadding = pathName !== '/' && !pathName.includes('/products/');
  return <footer className={cn('layout-container flex flex-col bg-gray-800 pb-3 pt-4 lg:gap-6 lg:pt-12', {
    'pb-18 lg:pb-3': hasBottomPadding
  })} data-sentry-component="Footer" data-sentry-source-file="footer.tsx">
            <section className='grid w-full grid-cols-1 pt-2 lg:grid-cols-2 lg:gap-32 lg:gap-6 lg:pt-0'>
                <Coulmns data-sentry-element="Coulmns" data-sentry-source-file="footer.tsx" />
                <ConnectionDetails data-sentry-element="ConnectionDetails" data-sentry-source-file="footer.tsx" />
            </section>
            <Certifications data-sentry-element="Certifications" data-sentry-source-file="footer.tsx" />
            <div className='mt-4 w-full text-center text-caption-10 text-text-lightGray lg:mt-0 lg:text-caption-12 lg:text-text-mediumGray'>
                کلیه حقوق این سایت متعلق به فروشگاه آنلاین خانومی می باشد.
            </div>
        </footer>;
}
export default Footer;